export default __webpack_public_path__ + "static/cp-screens-vertical-mobile-46fa87b51a50f1c7c653a77dd294db70.jpg";